export const SITE = {
  name: "Gazeta Regional Online",
  shortName: "Gazeta Regional",
  tagline: "Notícias, reviews e guias práticos para o dia a dia do leitor brasileiro",
  description:
    "Gazeta Regional Online é um webjornal independente com notícias atuais, reviews de produtos e serviços, guias passo a passo, tutoriais faça você mesmo e conteúdo tira-dúvidas para o leitor brasileiro.",
  baseUrl: "https://gazetaregionalonline.com.br",
  email: "redacao@gazetaregionalonline.com.br",
  social: {
    instagram: "https://www.instagram.com/",
    facebook: "https://www.facebook.com/",
    twitter: "https://twitter.com/",
  },
};

export const NAV = [
  { to: "/", label: "Capa" },
  { to: "/blog", label: "Editorias" },
  { to: "/sobre", label: "Sobre" },
  { to: "/equipe", label: "Redação" },
  { to: "/contato", label: "Contato" },
] as const;
